
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 8.667L2.667 5.333V12h6v1.333h-6c-.367 0-.68-.13-.942-.391A1.284 1.284 0 011.333 12V4c0-.367.13-.68.392-.942.261-.26.575-.391.942-.391h10.666c.367 0 .68.13.942.391.261.261.392.575.392.942v4.667h-1.334V5.333L8 8.667zm0-1.334L13.333 4H2.667L8 7.333zm-5.333-2v7.334-4 .05V4v1.333z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.267 11.067L9.333 12 12 14.667 14.667 12l-.934-.95-1.066 1.067V9.333h-1.334v2.784l-1.066-1.05z","fill":"currentColor"}})])
          )
        }
      }
    